import { Component, DoCheck, OnInit, Input } from "@angular/core";
import { NgbDropdownConfig } from "@ng-bootstrap/ng-bootstrap";
import { animate, style, transition, trigger } from "@angular/animations";
import { Router } from "@angular/router";
import { DattaConfig } from "src/app/config/app-config";
import { AuthSignInService } from "src/app/services/authentication/auth-signin.service";
import { languages } from "src/app/services/admin/localization/languages";
import { LocalizationHandlerService } from "src/app/services/admin/localization/localization-handler.service";

@Component({
  selector: "app-nav-right",
  templateUrl: "./nav-right.component.html",
  styleUrls: ["./nav-right.component.scss"],
  providers: [NgbDropdownConfig],
  animations: [
    trigger("slideInOutLeft", [
      transition(":enter", [
        style({ transform: "translateX(100%)" }),
        animate("300ms ease-in", style({ transform: "translateX(0%)" })),
      ]),
      transition(":leave", [
        animate("300ms ease-in", style({ transform: "translateX(100%)" })),
      ]),
    ]),
    trigger("slideInOutRight", [
      transition(":enter", [
        style({ transform: "translateX(-100%)" }),
        animate("300ms ease-in", style({ transform: "translateX(0%)" })),
      ]),
      transition(":leave", [
        animate("300ms ease-in", style({ transform: "translateX(-100%)" })),
      ]),
    ]),
  ],
})
export class NavRightComponent implements OnInit, DoCheck {
  public visibleUserList: boolean;
  public chatMessage: boolean;
  public friendId: boolean;
  public dattaConfig: any;
  @Input() IsSkyaccessApp: boolean = false;
  userName = "-";
  languages = languages;
  userData: any;
  SystemData: any;

  constructor(
    private LoginService: AuthSignInService,
    private authService: AuthSignInService,
    config: NgbDropdownConfig,
    private localizationHandler: LocalizationHandlerService,
    private router: Router
  ) {
    config.placement = "bottom-right";
    this.visibleUserList = false;
    this.chatMessage = false;
    this.dattaConfig = DattaConfig.config;
  }

  ngOnInit() {
    let user =
      atob(sessionStorage.getItem("userInfo")) !== "undefined"
        ? JSON.parse(atob(sessionStorage.getItem("userInfo")))
        : null;

    let Sys =
      atob(sessionStorage.getItem("SysInfo")) !== "undefined"
        ? JSON.parse(atob(sessionStorage.getItem("SysInfo")))
        : null;

    if (Sys !== null) {
      this.SystemData = {
        _EnterpriseName: Sys._EnterpriseName,
        _AosSysNumber: Sys._AosSysNumber,
      };
    }

    if (user !== null) {
      this.userData = { FirstName: user.FirstName, LastName: user.LastName };
    }
  }

  reloadCurrentPage() {
    const currentUrl = this.router.routerState.snapshot.url;
    const tempRoute = currentUrl.includes("dashboard/default")
      ? "/dashboard/summary"
      : "/";
    this.router
      .navigateByUrl(tempRoute, { skipLocationChange: true })
      .then(() => this.router.navigate([currentUrl]));
  }

  onChatToggle(friend_id) {
    this.friendId = friend_id;
    this.chatMessage = !this.chatMessage;
  }

  changeLanguage(value) {
    this.localizationHandler.changeLanguage(value);
  }

  currentSelection() {
    return this.localizationHandler.currentLang();
  }

  ngDoCheck() {
    if (document.querySelector("body").classList.contains("datta-rtl")) {
      this.dattaConfig["rtl-layout"] = true;
    } else {
      this.dattaConfig["rtl-layout"] = false;
    }
  }

  Logout() {
    this.LoginService.LogOut();
  }

  gotoprofile() {
    this.router.navigate(["/profile-management/profile"]);
  }
}
